import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';

import Layout from '../layout';

import APP_ROUTES from '../../constants/app-routes';

import styles from '../styles/pages/signin.scss';
import stylesComingSoon from '../styles/pages/coming-soon.scss';

import forgotPasswordImage from '../../images/forgot-password.png';

class SendEmail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            sentEmail: false,
        };

        this.handleFormSubmit = this.handleFormSubmit.bind(this);

        document.title = this.props.intl.formatMessage({ id: 'forgot-password', defaultMessage: 'Forgot Passowrd' });
    }

    componentDidMount() {
        // Redirect to home if is authenticated
        if (this.props.user && this.props.user.id) {
            this.props.dispatch(push(APP_ROUTES.homePageRoute));
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'forgot-password', defaultMessage: 'Forgot Password' });
        }
    }

    handleFormSubmit(formData) {
        this.props.submitEmailForm(formData, this.props.locale.currentLocale).then(
            (resp) => {
                if (resp) {
                    this.setState({ sentEmail: true });
                }
            },
            () => {},
        );
    }

    render() {
        const {
            handleSubmit, valid, submitting, intl,
        } = this.props;

        const { sentEmail } = this.state;
        const sentEmailMessage = (
            <div className={stylesComingSoon.comingContainer}>
                <div className="text-center" style={{ paddingBottom: 45 }}>
                    <img
                        style={{ maxWidth: '35%', height: 'auto' }}
                        src={forgotPasswordImage}
                        alt={this.props.intl.formatMessage({
                            id: 'not-found',
                            defaultMessage: 'Not',
                        })}
                    />
                </div>
                <h2 className={stylesComingSoon.mainText} style={{ paddingBottom: 10 }}>
                    <FormattedMessage id="send-email-success-1" defaultMessage="" />
                </h2>
                <h2 className={stylesComingSoon.mainText} style={{ paddingBottom: 10 }}>
                    <FormattedMessage id="send-email-success-2" defaultMessage="" />
                </h2>
            </div>
        );

        const emailForm = (
            <main className={`content ${styles.signin}`}>
                <div className={`container ${styles.bodyContainer}`}>
                    <section>
                        <p className={styles.titlePage}>
                            <FormattedMessage id="forgot-password" defaultMessage="Forgot Password" />
                        </p>
                        <div className="row">
                            <div className="col-lg-offset-4 col-lg-4 col-md-4 col-md-offset-4 col-sm-offset-3 col-sm-6 col-xs-12">
                                <form className={styles.form} onSubmit={handleSubmit(this.handleFormSubmit)}>
                                    <div>
                                        <div className={`form-group ${styles.formGroup}`}>
                                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 holder">
                                                <Field
                                                    className={styles.formInput}
                                                    name="user[email]"
                                                    component="input"
                                                    type="text"
                                                    autoComplete="off"
                                                    placeholder={intl.formatMessage({
                                                        id: 'email-address',
                                                        defaultMessage: 'Email Address',
                                                    })}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`form-group ${styles.formGroupHolder}`}>
                                        <button className="form-control btn btn-default" type="submit" disabled={!valid || submitting}>
                                            <span>
                                                <FormattedMessage id="send" defaultMessage="Send" />
                                            </span>
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
                </div>
            </main>
        );

        return (
            <Layout>
                {sentEmail ? (
                    sentEmailMessage
                ) : (
                    emailForm
                )}
            </Layout>
        );
    }
}

SendEmail = reduxForm({
    form: 'sendEmail',
})(SendEmail);

export default injectIntl(SendEmail);



/** WEBPACK FOOTER **
 ** ./src/components/pages/send-email.jsx
 **/